<template>
  <div class="row align-center homeEmenta" id="ementa">
    <div class="columns small-12 medium-12 large-9">
      <HomeSectionTitle 
        class="xpto"
        :title="$t('UMA_LANG_SASUMA_HOME_EMENTASEMANAL')" />
      <div id="consultalocalContent">
        <EmentaList />
        <router-link to="/alimentacao" class="morelinks">
            <i class="fa fa-plus-square-o"></i>
            {{ $t("UMA_LANG_SASUMA_VERMAIS") }}
        </router-link>
      </div>
    </div>
  </div>
</template>
  
<script>
import HomeSectionTitle from "@/components/HomeSectionTitle.vue";
import EmentaList from "@/components/Ementa/EmentaList.vue";

export default {
  components:{
    HomeSectionTitle,
    EmentaList
  }
}
</script>
<style>
@media (max-width: 767px) {
  .xpto{
    --carousel-title-padding-top-mobile: 0;
  }
}
</style>

<style lang="scss" scoped>
.homeEmenta{
  padding-bottom: 85px;
}

.homeEmenta .morelinks{
  color: #6eb7ec;
  text-transform: uppercase;
  display: flex;
  font-size: 15px;
  align-items: center;
}

.morelinks {
    font-size: 15px;
    font-family: 'Montserrat Bold';
    color: white;
}

.morelinks {
    padding-left: 16px;
}

.morelinks i {
    margin-right: 10px;
    font-size: 24px;
}

.morelinks, .morelinks:hover{
  color: #6eb7ec;
  left: 0;
  bottom: 0;
  z-index: 50;
  text-transform: uppercase;
  display: flex;
  font-size: 15px;
  align-items: center;
}

@media (max-width: 767px) {
  .homeEmenta {
    padding-top: 50px;
  }

  .homeEmenta .morelinks{
    margin-top: 30px;
  }
}
</style>